import request from '@/utils/request'
import host from '@/api/base/host'

// 课程分享
const integral = host.path('loca:ljs', { module: 'integral', dev: 'v1' })

export default {
  // 积分明细
  acountDetail(data) {
    return request({
      url: integral('credit/account/detail'),
      method: 'post',
      data
    })
  },
  // 积分首页
  integralInfo(data) {
    return request({
      url: integral('credit/account/overview'),
      method: 'post',
      data
    })
  },
  // 邀请绑定
  inviteBind(data) {
    return request({
      url: integral('credit/invite'),
      method: 'post',
      params: data
    })
  },
  getActivityList(data) {
    return request({
      url: integral('credit/market/recommends'),
      method: 'post',
      params: data
    })
  }
}
